import { get, isEmpty, forEach } from 'lodash';
import {
    GET_PRODUCT_DETAILS_SUCCESS,
    INIT_GIFT_CARD_BANNER_VALUE,
    SHOW_GIFT_CARD_BANNER,
    ADD_GIFT_CARD_TO_CART_MESSAGE,
    UPDATE_GIFT_CARD_BANNER_SELECTED_VALUE,
    INIT_NEW_GIFT_CARD_BANNER_VALUE,
    HIDE_GIFT_CARD_BANNER_MESSAGE,
} from '../actionTypes/AddItemToCartActionTypes';

export default function GiftCardBannerReducer(state = { showGCMsgBanner: false }, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_PRODUCT_DETAILS_SUCCESS: {
            const { data } = action;
            const imageUrl = get(data, 'images[0].url', '');
            const dropDownValues = [];
            let selectedValue;
            forEach(data.lots, (lot) => {
                const optionsValues = get(lot, 'items[0].optionValues[0]', {});
                const options = {
                    key: get(lot, 'items[0].offering.href', ''),
                    value: optionsValues.value,
                    number: optionsValues.value.replace('$', ''),
                };
                if (
                    action.amountShortForShippingDiscount &&
                    !selectedValue &&
                    parseInt(options.number, 10) >=
                        parseInt(action.amountShortForShippingDiscount, 10)
                ) {
                    selectedValue = options;
                }
                dropDownValues.push(options);
            });
            return {
                imageUrl,
                dropDownValues,
                selectedValue,
                showGiftCardBanner: dropDownValues.length !== 0,
            };
        }

        case INIT_GIFT_CARD_BANNER_VALUE: {
            if (!state.dropDownValues) return state;
            let selectedValue;
            forEach(state.dropDownValues, (option) => {
                if (
                    action.amountShortForShippingDiscount &&
                    !selectedValue &&
                    parseInt(option.number, 10) >=
                        parseInt(action.amountShortForShippingDiscount, 10)
                ) {
                    selectedValue = option;
                }
            });
            return { ...state, selectedValue, showGiftCardBanner: true };
        }

        case UPDATE_GIFT_CARD_BANNER_SELECTED_VALUE: {
            if (!state.dropDownValues) return state;
            let selectedValue;
            forEach(state.dropDownValues, (option) => {
                if (option.key === action.key) {
                    selectedValue = option;
                }
            });
            return { ...state, selectedValue, showGCMsgBanner: false };
        }

        case SHOW_GIFT_CARD_BANNER: {
            return { ...state, showGiftCardBanner: action.value };
        }

        case ADD_GIFT_CARD_TO_CART_MESSAGE: {
            const {
                status: { freeShipping, isSuccess, showGCMsgBanner, showGiftCardBanner },
            } = action;
            return { ...state, showGiftCardBanner, freeShipping, isSuccess, showGCMsgBanner };
        }

        case HIDE_GIFT_CARD_BANNER_MESSAGE: {
            return { ...state, showGCMsgBanner: false };
        }

        case INIT_NEW_GIFT_CARD_BANNER_VALUE: {
            const data = action.data.gcfreeshipping.giftcard;
            const imageUrl = data.bannerImgURL;
            const { bannerText } = data;
            const dropDownValues = [];
            let selectedValue;
            forEach(data.skulist, (sku) => {
                const optionsValues = get(sku, 'value', null);
                const ppId = get(sku, 'ppId', null);
                const skuId = get(sku, 'id', null);
                const options = {
                    key: get(sku, 'sku', ''),
                    value: optionsValues,
                    number: skuId,
                    ppId,
                };
                if (action.data.gid === skuId) {
                    selectedValue = options;
                }
                dropDownValues.push(options);
            });

            if (isEmpty(selectedValue)) {
                selectedValue = dropDownValues[0];
            }

            const updatedState = {
                imageUrl,
                dropDownValues,
                selectedValue,
                bannerText,
                showGiftCardBanner: dropDownValues.length !== 0,
                source: action.data,
            };
            if (action.options && action.options.isInitGCBannerAddSuccess) {
                updatedState.isSuccess = true;
                updatedState.freeShipping = false;
                updatedState.showGCMsgBanner = true;
            }
            return updatedState;
        }
        default:
            return state;
    }
}
